/* External */
import { memo } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

/* Ott-common */
import LiveStartTimeCommon from '@dtvgo/live-start-time';

/* Utils */
import { useCurrentTime } from '../../providers/CurrentTimeProvider';
import useLiveContentTexts from '../../hooks/useLiveContentTexts';

function LiveStartTime({
  startDate,
  endDate,
  children,
  className,
  showStartInText,
  showLiveIcon,
}) {
  const { formatMessage, timeZone } = useIntl();
  return (
    <LiveStartTimeCommon
      currentTime={useCurrentTime()}
      startDate={startDate}
      endDate={endDate}
      formatTextTime={useLiveContentTexts()}
      className={className}
      textLive={formatMessage({ id: 'common.live' })}
      showStartInText={showStartInText}
      showLiveIcon={showLiveIcon}
      timeZone={timeZone}
    >
      {children}
    </LiveStartTimeCommon>
  );
}

LiveStartTime.defaultProps = {
  startDate: undefined,
  endDate: undefined,
  className: '',
  showStartInText: true,
  children: undefined,
  showLiveIcon: true,
};

LiveStartTime.propTypes = {
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  children: PropTypes.node,
  className: PropTypes.string,
  showStartInText: PropTypes.bool,
  showLiveIcon: PropTypes.bool,
};

export default memo(LiveStartTime);
